import React from "react";
import "./styles.css";
import Anchor from "../UI/anchor";
import AlliancesImg from "../../assets/img/woman-exclamation.png";
import { whatsappTramy } from "../../constants/urls";
import { alliancesIntro, alliancesBenefits } from "../../constants/contents";

function AlliancesInfo() {
  return (
    <div className="alliances-info">
      <h1>Conviértete en un Aliado</h1>
      <div className="alliances-info__content">
        <span>
          <ul>
            {alliancesIntro}
            {alliancesBenefits.map((alliancesBenefit) => (
              <li>{alliancesBenefit}</li>
            ))}
          </ul>
          <Anchor
            text={"Más información"}
            background={"#109cf1"}
            color={"white"}
            link={whatsappTramy}
          />
        </span>
        <img src={AlliancesImg} alt="surprised woman" />
      </div>
    </div>
  );
}

export default AlliancesInfo;
